export default class MigrateFavoriteAnswers {
  constructor(context) {
    this.context = context;
  }

  run() {
    const agentPreferences = this.context.stores.agentPreferences.get();
    const ids = agentPreferences.favoriteAnswerIds;
    if (!ids || !ids.length) {
      return;
    }

    return this.context.gateways.favoriteAnswers
      .requestAll()
      .catch(() => [])
      .then(existingDtos => {
        const existingIds = new Set((existingDtos || []).map(dto => dto.answerId));
        const newIds = ids.filter(id => !existingIds.has(id));
        if (!newIds.length) {
          return;
        }
        const promises = newIds.map(answerId => this.context.gateways.favoriteAnswers.add({ answerId }));
        return Promise.all(promises);
      });
  }
}
